<template>
  <tr>
    <td>{{task.category_id}}</td>
    <td>{{task.name}}</td>
    <td>
      <input disabled type="checkbox" id="checkbox" v-model="task.is_menu" />
      <label for="checkbox">{{ task.is_menu }}</label>    
    </td>
    <td>
      <div class="container">
        <button type="button" class="btn btn-warning btn-block" @click="seleccionar">edit</button>
      </div>
    </td>
  </tr>
</template>
<script>
export default {
  name: "Category",
  props: {
    task: {
      category_id: Number,
      name: String,
      is_menu: Boolean
    }
  },
  methods: {
    seleccionar() {
      this.$store.dispatch("selectTaskAction", this.task);
    }
  }
};
</script>
<style>
</style>